export const fundingAnnounceContent = `
<img src="/announce/StudioAtelicoTeam.jpg" height="100px" alt="Studio Atelico Team" />

We [recently raised $5 million in seed funding](https://gamesbeat.com/studio-atelico-raises-5m-to-transform-gaming-experiences-for-players-and-devs-with-ai/). 🎉
<br/>
<br/>
Cool. Another AI startup raising money. You might be tired of these headlines, but, for us, it’s a green light. One that lets us build the things we’ve always dreamed about. Not “AI for AI’s sake.” Not “Web3 meets the metaverse meets buzzword salad.” Just… better games. New kinds of games. Games that feel alive. And AI is the tech to make that happen.
<br/>
<br/>

Here’s what we’re doing with that money, and why it matters to us.

<br/>

---

## **1\. Games That Couldn’t Exist Before**

We’re using this funding to build games that push past the boundaries of hand-authored pipelines. We don’t mean “generate a few trees procedurally.”  We mean **reactive worlds, characters that riff off your choices like improv actors, stories that don’t just branch but bloom.** This is the kind of gameplay we’ve always wanted as players, and now we finally have the tech (and the team) to make it real.

The first game from Studio Atelico is already in production and we can’t wait to share more soon.

<br/>

---

## **2\. Tools That Empower Developers, Not Just Us**

We’re not just making games. We’re also building the **Atelico Engine**, a toolkit that helps us and other studios bring AI-powered experiences to life without massive budgets or custom infrastructure.

These tools are designed for teams like ours: small, creative, and bold. If a system makes our work better, we’ll make sure it’s available to others too.

<br/>

---

## **3\. A Clear Ethical Line on AI**

Ethics aren’t an afterthought, they’re part of our foundation. We’re working directly with artists to ensure fairness, consent, compensation, and collaboration are part of every step, from model training to revenue sharing.

We’re choosing on-device AI when we can, partnering with creators who share our values, and contributing to open datasets that prioritize ethics over speed.

**We believe creativity should be amplified, not replaced.**

<br/>

---



## **New Faces, New Chapters**

We’re also thrilled to welcome [Chris Olson](https://www.linkedin.com/in/xispo/) to the team. With deep experience in mobile games, studio leadership, and scaling creative teams, Chris is helping us bring our vision to players around the world.

<br/>

---



## **The Journey Ahead**
This funding round was led by Nathan Benaich of Air Street Capital, with support from Parin Shah and Talfan Evans from Clay, Chris Ré and Samuel Jackson from Factory, Tommaso Moraca and Isabella Timossi at Vento, angels including Thomas Wolf, Diego Oppenheimer, Alex Ratner, Theofanis Karaletsos, Maurizio Sciglio, Jacopo Tagliabue, Pancrazio Auteri and Alex Fred-Ojala and Marcus Zethraeus at Predii. An amazing group of folks who understand both AI and games. It’s a vote of confidence in our approach, but more importantly, it’s a chance to build something new and to build it right.
<br/>
<br/>

[**We’re hiring**](https://atelico.studio/careers/art-director). We’re experimenting. And we’re here to learn alongside anyone who believes that the future of games should be more creative, more collaborative, and more fun.

Thanks for being part of the ride.

[**Reach out**](mailto:hello@atelico.studio) if you’re a studio or artist who wants to collaborate.`;

export default fundingAnnounceContent;
